export default "__VITE_ASSET__fe56f480__"